const STORAGE_KEY = 'zrm.markedPaidBannerDismissedPayments';

export const MARKED_PAID_BANNER_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

type DismissedPayments = Record<string, number>;

const readStore = (): DismissedPayments => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
};

export const getDismissedMarkedPaymentKeys = (): Array<string> => {
  const store = readStore();
  return Object.keys(store).filter((key) => Date.now() - store[key] <= MARKED_PAID_BANNER_WINDOW_MS);
};

export const dismissMarkedPayments = (keys: Array<string>): void => {
  try {
    const store = readStore();
    const now = Date.now();
    const pruned: DismissedPayments = {};
    for (const key of Object.keys(store)) {
      if (now - store[key] <= MARKED_PAID_BANNER_WINDOW_MS) {
        pruned[key] = store[key];
      }
    }
    for (const key of keys) {
      pruned[key] = now;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(pruned));
  } catch {
    // localStorage unavailable
  }
};
